import { V } from "../../app/pages.js";
import { can, emp, leaveScope, me, uname } from "../../services/access.js";
import { esc } from "../../domain/format.js";
import { LEAVE_TYPES } from "../../domain/reference.js";
import { fmtD } from "../../domain/dates.js";
import { ssn } from "../../components/ui.js";
import { plantLeavePanel } from "../hrm/foundation.js";

V.leave = () => {
  const list = leaveScope().filter((l) => l.source !== "HRM_PLANT"),
    u = me();
  return `<section class="panel"><div class="panel-h"><div><h2>Leave requests</h2><span class="small muted">${can("leave.all") ? "All departments" : u.dept + " department"}</span></div></div>
   <div class="tbl"><table><thead><tr><th>Employee</th><th>Type</th><th>Dates</th><th class="n">Days</th><th>Reason</th><th>Status</th><th></th></tr></thead><tbody>
   ${
     list.length
       ? list
           .slice()
           .reverse()
           .map(
             (
               l,
             ) => `<tr><td>${esc(emp(l.emp).name)}<div class="small muted">${esc(emp(l.emp).dept)}</div></td><td>${esc(LEAVE_TYPES[l.type])}</td><td>${fmtD(l.from)} – ${fmtD(l.to)}</td><td class="n">${l.days}</td><td>${esc(l.reason)}</td><td>${ssn(l.status)}${l.by ? `<div class="small muted">${esc(uname(l.by))}</div>` : ""}</td>
    <td>${l.status === "PENDING" ? `<div class="row"><button data-act="lv-ok" data-id="${l.id}">Approve</button><button class="ghost" data-act="lv-no" data-id="${l.id}">Reject</button></div>` : ""}</td></tr>`,
           )
           .join("")
       : `<tr><td colspan="7" class="muted">No requests in your scope.</td></tr>`
   }
   </tbody></table></div></section>${plantLeavePanel()}`;
};
